/* eslint-disable operator-linebreak */
import { createAction } from '@reduxjs/toolkit';

export const GENERATE_OTP_REQUEST = 'GENERATE_OTP_REQUEST';
export const GENERATE_OTP_SUCCESS = 'GENERATE_OTP_SUCCESS';
export const GENERATE_OTP_FAILED = 'GENERATE_OTP_FAILED';

export const MATCH_OTP_REQUEST = 'MATCH_OTP_REQUEST';
export const MATCH_OTP_SUCCESS = 'MATCH_OTP_SUCCESS';
export const MATCH_OTP_FAILED = 'MATCH_OTP_FAILED';

export const NEW_PASSWORD_REQUEST = 'NEW_PASSWORD_REQUEST';
export const NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS';
export const NEW_PASSWORD_FAILED = 'NEW_PASSWORD_FAILED';

export const TOGGLE_OTP_MODAL = 'TOGGLE_OTP_MODAL';
export const REMOVE_FORGOT_PASSWORD_ERROR = 'REMOVE_FORGOT_PASSWORD_ERROR';

export interface IGenerateOtpRequest {
	recipient: string;
	purpose: number;
	vendor: number;
	type?: string;
}

export interface IGenerateOtpResponse {
	transactionId: number;
	expiredAt: string;
	createdAt: string;
	otpCode: string;
}

export interface IMatchOtpRequest {
	transactionId: number;
	otpCode: string;
	recipient: string;
	type: string;
}

export interface IMatchOtpResponse {
	isMatch: boolean;
	isExpired?: boolean;
	user?: Record<string, unknown>;
	purpose_data?: {
		forgot_pasword_token?: string;
	};
	failed_match_count?: number;
}

export interface INewPasswordRequest {
	phoneNumber: string;
	newPassword: string;
	confirmPassword: string;
	type: string;
	forgotPasswordToken: string;
}

export interface INewPasswordSuccess {
	message: string;
}

export const generateOtpAction =
	createAction<IGenerateOtpRequest>(GENERATE_OTP_REQUEST);
export const generateOtpResultSuccessAction =
	createAction<IGenerateOtpResponse>(GENERATE_OTP_SUCCESS);
export const generateOtpResultFailedAction =
	createAction<string>(GENERATE_OTP_FAILED);
export const matchOtpRequestAction =
	createAction<IMatchOtpRequest>(MATCH_OTP_REQUEST);
export const matchOtpResultSuccessAction =
	createAction<IMatchOtpResponse>(MATCH_OTP_SUCCESS);
export const matchOtpResultFailedAction =
	createAction<string>(MATCH_OTP_FAILED);
export const newPasswordRequestAction =
	createAction<INewPasswordRequest>(NEW_PASSWORD_REQUEST);
export const newPasswordSuccessAction =
	createAction<INewPasswordSuccess>(NEW_PASSWORD_SUCCESS);
export const newPasswordFailedAction =
	createAction<string>(NEW_PASSWORD_FAILED);
export const removeForgotPasswordErrorAction = createAction<string>(
	REMOVE_FORGOT_PASSWORD_ERROR
);
export const toggleOtpModalAction = createAction<boolean>(TOGGLE_OTP_MODAL);
